import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

var firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAtWlS6h8Hrq7EmwWZFr_r0Iny3rVcuf7U",
  authDomain: "ecommerce-website-f0a61.firebaseapp.com",
  projectId: "ecommerce-website-f0a61",
  storageBucket: "ecommerce-website-f0a61.appspot.com",
  messagingSenderId: "46603477060",
  appId: "1:46603477060:web:1d221511bfa4de02489c11",
  measurementId: "G-Z6M0Y6D1KN",
});

var db = firebaseApp.firestore();
export { db };
